
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { extend, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', required);

@Component({
  name: 'checkout-payment-methods-default',
  components: {
    ValidationProvider,
  },
})
export default class extends Vue {
  @Ref('order') readonly order!: HTMLButtonElement;
  @Prop({ required: true }) private paymentMethod: object;
  @Prop() private selectedPaymentMethod: object;


  private vatId: string = '';
  private cocNumber: string = '';

  private get customerAddress(): object {
    return this.$store.state['CheckoutAddress']['shippingAddress'];
  }
  private get methodSubTitle(): object {
    switch (this.paymentMethod['code']) {
      case 'paynl_payment_ideal':
        return {
          tooltip: 'Met iDEAL kunt  u met een Nederlandse bankrekening vertrouwd, veilig en gemakkelijk betalen via internetbankieren van uw eigen bank.',
          subtitle: this.$t('Free')
        };
      case 'paynl_payment_afterpay':
        return {
          tooltip: null,
          subtitle: this.$t('Free'),
        };
      case 'paynl_payment_mistercash':
        return {
          tooltip: 'U kunt met Bancontact vertrouwd, veilig en gemakkelijk betalen via internetbankieren van uw eigen bank, wanneer u een Belgische bankrekening heeft.',
          subtitle: this.$t('Belgium'),
        };
      case 'paynl_payment_overboeking':
        return {
          tooltip:
            'Nadat je je bestelling hebt geplaatst, krijg je een scherm met betaalinstructies van onze betaalpartner Pay.nl te zien. Deze instructies worden tevens naar je opgegeven e-mailadres gestuurd. Je bestelling zal verstuurd worden zodra de betaling door ons ontvangen is. Let op: Het verwerken van de betaling duurt 1 tot 2 werkdagen.',
          subtitle: this.$t('Free'),
        };
      case 'paynl_payment_maestro':
      case 'paynl_payment_visamastercard':
        return {
          tooltip: null,
          subtitle: this.$t('Free'),
        };
      case 'paynl_payment_payconiq':
        return {
          tooltip: null,
          subtitle: this.$t('Free'),
        };
      case 'paynl_payment_capayable_gespreid':
        return {
          tooltip: null,
          subtitle: this.$t('Free'),
        };
      case 'giftcard':
        return {
          tooltip: this.$store.state['CheckoutPayment']['paymentMethodConfig']['giftcard']['name'] || '',
          subtitle: null,
        };
      default:
        return {
          tooltip: null,
          subtitle: this.$t('Free'),
        };
    }
  }

  private get isActiveMethod(): boolean {
    return this.selectedPaymentMethod['code'] === this.paymentMethod['code'];
  }

  private async changeSelectedPaymentMethod(): Promise<void> {
    if (this.paymentMethod['code'] === 'paynl_payment_billink' && this.customerIsBusinessAccount) {
      this.prefillB2BFields();
    }

    await this.$store.commit('CheckoutPayment/CLEAR_PAYMENT_DETAILS');
    await this.$store.dispatch('CheckoutPayment/setSelectedPaymentMethod', this.paymentMethod);
    await this.$store.dispatch('CheckoutPayment/setPaymentMethod', this.paymentMethod);


  }

  private get customerIsBusinessAccount(): string {
    return this.$store.getters['CheckoutGlobal/isBusinessAccount'] || '';
  }
  private prefillB2BFields(): void {
    if (this.customerAddress['vat_id']) {
      this.vatId = this.customerAddress['vat_id'];
      this.$nextTick(() => {
        // this.$refs['vat_id'].validate();
        this.$store.commit('CheckoutPayment/ADD_PAYMENT_DETAILS', {vatid: this.vatId});
      });



    }

    if (this.customerAddress['coc_number']) {
      this.cocNumber = this.customerAddress['coc_number'];
      this.$nextTick(() => {
        // this.$refs['coc_number'].validate();
        this.$store.commit('CheckoutPayment/ADD_PAYMENT_DETAILS', {cocnumber: this.cocNumber});
      });

    }
  }
  private addB2BInfoToPayment(): void {
    this.$store.commit('CheckoutPayment/ADD_PAYMENT_DETAILS', {vatid: this.vatId, cocnumber: this.cocNumber});
  }


}
